







































































































































































































import {ObjectFactory} from '@/config/objectFactory';
import {EventBus} from '@/main';
import {OrgLocation, ServiceRequest} from '@/types/entity';
import {ToastEvent} from '@/types/event';
import {ApiRequest, EditSpecificDetailsRequest} from '@/types/request';
import {CommonUtils} from '@/util/commonUtils';
import {MedTransGoConstants} from '@/util/constants';
import {Component, Vue} from 'vue-property-decorator';
import {ModelSelect} from 'vue-search-select';
import {email, minLength, required} from 'vuelidate/lib/validators';
import {ApiResponse} from '@/types/response';

@Component({
    props: {
        request: Object,
        activeTab: Boolean,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            facilityName: '',
            facilityemail: '',
            facilityPhone: '',
            coordinatorName: '',
            coordinatorEmail: '',
            coordinatorPhone: '',
            additionalNotes: '',
            rxAdditionalNotes: '',
            additionalContacts: [],
            billingLocationName: '',
            billingLocation: {
                name: '',
                address: '',
                insuranceCompany: '',
                adjusterEmail: '',
            },
            orgLocations: [],
        };
    },
    validations: {
        fullName: {
            required,
            regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone) =>
                MedTransGoConstants.PHONE_REGX.test(phone),
        },
        facilityName: {
            required,
            regex: (facilityName: string) => /^[a-zA-Z ]+$/.test(facilityName),
        },
        facilityemail: {
            required,
            email,
        },
        facilityPhone: {
            required,
            minLength: minLength(10),
            regex: (phone) =>
                MedTransGoConstants.PHONE_REGX.test(phone),
        },
        coordinatorName: {
            required,
            regex: (coordinatorName: string) => /^[a-zA-Z ]+$/.test(coordinatorName),
        },
        coordinatorEmail: {
            required,
            email,
        },
        coordinatorPhone: {
            required,
            minLength: minLength(10),
            regex: (phone) =>
                MedTransGoConstants.PHONE_REGX.test(phone),
        },
        additionalNotes: {
            required,
            regex: (additionalNotes: string) => /^[a-zA-Z ]+$/.test(additionalNotes),
        },
        rxAdditionalNotes: {
            required,
            regex: (rxAdditionalNotes: string) => /^[a-zA-Z ]+$/.test(rxAdditionalNotes),
        },
        additionalContacts: {
            $each: {
                contactName: {
                    required,
                },
                relationshipToPatient: {
                    required,
                },
                email: {
                    email,
                },
                phone: {
                    minLength: minLength(10),
                    regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                },
            },
        },
    },
})
export default class EditServiceRequestModal extends Vue {
    private show = true;
    private isInterpretationRequest = false;
    private haveAdditionalStop = false;
    private isTransportRequest = false;
    public mounted() {
        this.getRequestDetails();
    }
    private close() {
        if (this.$props.activeTab) {
            this.$emit('close');
        } else {
            this.$router.go(-1);
        }
    }

    private async editRequestDetails() {
        const iHttpService = ObjectFactory.getHttpService();
        const updaterequest: EditSpecificDetailsRequest = {
          fullName: this.$data.fullName,
          email: this.$data.email,
          phone: this.$data.phone,
          facilityName: this.$data.facilityName,
          facilityemail: this.$data.facilityemail,
          facilityPhone: this.$data.facilityPhone,
          coordinatorName: this.$data.coordinatorName,
          coordinatorEmail: this.$data.coordinatorEmail,
          coordinatorPhone: this.$data.coordinatorPhone,
          additionalNotes: this.$data.additionalNotes,
          rxAdditionalNotes: this.$data.rxAdditionalNotes,
          billingLocation: this.$data.billingLocation,
          additionalContacts: this.$data.additionalContacts.map((contact: any) => {
            if (!contact.isSMS) {
                contact.phone = '';
            }
            if (!contact.isEmail) {
                contact.email = '';
            }
            return contact;
          }),
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${this.$props.request.id}/updaterequest`,
            data: updaterequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<ServiceRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('Updated successfully'),
                title: 'Success',
                varient: 'success',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }

    private onLocationChanged(event: any) {
        const selectedLocation = this.$data.orgLocations.find((location: { locationName: any; }) =>
            location.locationName === event.target.value);
        if (selectedLocation) {
            this.$data.billingLocation = {
                name: selectedLocation.locationName,
                address: selectedLocation.locationAddress,
                insuranceCompany: selectedLocation.insuranceCompany,
                adjusterEmail: selectedLocation.adjusterEmail,
            };
        } else {
            this.$data.billingLocation = {
                name: selectedLocation.locationName,
                address: selectedLocation.locationAddress,
                insuranceCompany: selectedLocation.insuranceCompany,
                adjusterEmail: selectedLocation.adjusterEmail,
            };
        }
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

    private async getRequestDetails() {
        const id = this.$props.request.id || this.$route.params.id;
        const response = await ObjectFactory.getRequestService().getRequestDetails(id, this.$store.state.serverUrl);
        if (response.data && response.success) {
            this.$data.fullName = response.data.appointment.patient.fullName;
            this.$data.email = response.data.appointment.patient.email;
            this.$data.phone = response.data.appointment.patient.phone;
            this.$data.facilityName = response.data.appointment.facility.name;
            this.$data.facilityemail = response.data.appointment.facility.email;
            this.$data.facilityPhone = response.data.appointment.facility.phone;
            this.$data.coordinatorName = response.data.appointment.coordinator.name;
            this.$data.coordinatorEmail = response.data.appointment.coordinator.email;
            this.$data.coordinatorPhone = response.data.appointment.coordinator.phone;
            this.$data.additionalNotes = response.data.additionalNotes;
            this.$data.billingLocation = response.data.billingLocation;
            this.$data.billingLocationName =  response.data.billingLocation.name;

            if (response.data && response.data.rxAdditionalNotes) {
                this.$data.rxAdditionalNotes = response.data.rxAdditionalNotes;
            }
            if (response.data && response.data.additionalContacts) {
                this.$data.additionalContacts = response.data.additionalContacts;
            }
            this.show = true;
            if (response.data.interpreterRequest) {
                this.isInterpretationRequest = true;
            }
            if (response.data.transportRequest) {
                this.isTransportRequest = true;
            }
            if (response.data.transportRequest &&
                response.data.transportRequest.
                    mapRoutes[response.data.transportRequest.mapRoutes.length - 1].additionalStops) {
                this.haveAdditionalStop = true;
            }
            if (response.data.organizationId) {
                const locationResponse = await this.getOrganizationLocations(response.data.organizationId);
                if (locationResponse.success && locationResponse.data) {
                    locationResponse.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
                }
                this.$data.orgLocations = locationResponse.data;
            }
        }
    }

    private async getOrganizationLocations(organizationId: string): Promise<ApiResponse<OrgLocation[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/
                    ${organizationId}/locations`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<OrgLocation[]>(apiRequest);
        return response;
    }

    private addContact() {
        this.$data.additionalContacts.push({
            contactName: '',
            relationshipToPatient: '',
            isSMS: false,
            isEmail: false,
            phone: '',
            email: '',
        });
    }

    private deleteContact(index: any) {
        this.$data.additionalContacts.splice(index, 1);
    }
}
